/* global axios */
import ApiClient from './ApiClient';

class OperationsAPI extends ApiClient {
  constructor() {
    super('operations', { accountScoped: true });
  }

  dashboard() {
    return axios.get(`${this.url}/dashboard`);
  }

  health() {
    return axios.get(`${this.url}/health`);
  }

  channelHealth() {
    return axios.get(`${this.url}/channel_health`);
  }

  acknowledgeRisk(id) {
    return axios.post(`${this.url}/risks/${id}/acknowledge`);
  }

  retryMessage(id) {
    return axios.post(`${this.url}/messages/${id}/retry`);
  }

  followUps() {
    return axios.get(`${this.baseUrl()}/conversation_follow_ups`);
  }

  createFollowUp(data) {
    return axios.post(`${this.baseUrl()}/conversation_follow_ups`, data);
  }

  completeFollowUp(id) {
    return axios.patch(`${this.baseUrl()}/conversation_follow_ups/${id}`, {
      completed: true,
    });
  }

  scheduledMessages() {
    return axios.get(`${this.baseUrl()}/scheduled_messages`);
  }

  scheduleMessage(data) {
    return axios.post(`${this.baseUrl()}/scheduled_messages`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  cancelScheduledMessage(id) {
    return axios.delete(`${this.baseUrl()}/scheduled_messages/${id}`);
  }
}

export default new OperationsAPI();
